
/* eslint-disable import/prefer-default-export */
export const ActiveChart = {
  activeChartRequest: 'ACTIVE_CHART_PENDING',
  activeChartSuccess: 'ACTIVE_CHART_SUCCESS',
  activeChartError: 'ACTIVE_CHART_ERROR',

  modifyChartRequest: 'MODIFY_CHART_PENDING',
  modifyChartSuccess: 'MODIFY_CHART_SUCCESS',

  createChartRequest: 'CREATE_CHART_PENDING',
  createChartSuccess: 'CREATE_CHART_SUCCESS',

  fetchTestChartDataRequest: 'FETCH_TEST_CHART_DATA_PENDING',
  fetchTestChartDataSuccess: 'FETCH_TEST_CHART_DATA_SUCCESS',
};

